import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const accountServices = {
  addNewAccount,
  updatedAccount,
  deleteAccount,
  getAccountList,
};

// Add New Account
async function addNewAccount(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewAccount`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Account
async function updatedAccount(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedAccount`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Account
async function deleteAccount(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteAccount`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Account
async function getAccountList(status) {
  try {
    const signal = cancelPreviousRequest(`getAccountList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getAccountList/${status}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}